// component
import OrderItems from "./OrderItemes";
import { CustomInput, ReactSelect, CheckInput } from "../kits/Inputs/Inputs";
import CustomButton from "../kits/button/CustomButton";
import DatePiker from "../datepiker/datePiker";
import useAxios from "../../services/useAxios";
import { translateToReactSelect } from "../../utils/helperFunction";
import ToastCustomize from "../kits/ToastCustomize";

import { useNavigate, useParams } from "react-router-dom";

import { mobileChecker } from "../../utils/regexCheckers";

import { ArrowBottomIcon } from "../kits/Icons";

// react
import { useState, useEffect, useMemo } from "react";
// style
import ColorSchema from "../kits/Color";
import "./AddAndEdit.scss";
import { addCommas } from "@persian-tools/persian-tools";

export default function AddAndEdit({
  type, //add,edit
  orderData,
}) {
  let navigate = useNavigate();
  let { orderId } = useParams();
  const priceType = [
    { value: "-1", label: "بی تاثیر" },
    { value: "1", label: "درصد" },
    { value: "2", label: "مبلغ" },
  ];
  const orderType = [
    { value: "1", label: "خرید" },
    { value: "2", label: "فروش" },
  ];
  // useAxios
  const { execute: getProduct } = useAxios("api2/product_list");
  const { execute: getUserActive } = useAxios("api2/Find_Customers");
  const { execute: addOrder } = useAxios("api2/add_order");
  const { execute: editOrderApi } = useAxios("api2/edit_order");
  const { execute: findFabrics } = useAxios("api/Find_Fabrics");

  // state
  const [items, setItems] = useState([]);
  const [allFabrics, setAllFabrics] = useState([]);
  const [fullInfo, setFullInfo] = useState({
    customerId: "",
    recipient_name: "",
    recipient_phone: "",
    delivery_address: "",
    CheckInput: "",
    operator_delivery_tm: 0,
    save_tm: 0,
    tax: 0,
    toll: 0,
    type: 1,
    items: [
      // {
      //   product: {},
      //   count: "",
      //   price: "",
      //   discount: "",
      //   totalPrice: "",
      //   options: [],
      //   id: 0,
      // },
    ],
  });
  const [textError, setTextError] = useState({
    recipient_phone: "",
    customer: "",
    recipient_name: "",
    delivery_address: "",
    time: "",
    items: "",
  });
  const errorHandler = (object) => {
    setTextError((prev) => {
      return { ...prev, ...object };
    });
  };
  const [recipient, setRecipient] = useState({
    fname: "",
    lname: "",
    recipient_phone: "",
    delivery_address: "",
    CheckInput: "",
  });

  const submitButtonIsDisable = useMemo(
    () =>
      fullInfo.items?.some(
        (val) => !val.isChecked && val.product.product_structure_id != 4
      ),
    [fullInfo.items]
  );

  const changeHandler = (value, name, index) => {
    setRecipient((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const submitHandler = (state) => {};

  const changeHandlerFullInfo = (object, type, index) => {
    if (type == "item") {
      setFullInfo((prev) => {
        return {
          ...prev,
          items: prev.items?.map((val) => {
            if (val.id == index) {
              let isChecked = true;
              if (+fullInfo.type === 2) {
                isChecked = val.isChecked
                  ? !Object.keys(object).some((k) =>
                      [
                        "product",
                        "height",
                        "width",
                        "garamaj",
                        "pieces",
                      ].includes(k)
                    )
                  : val.isChecked;
              }

              return { ...val, isChecked, ...object };
            } else {
              return val;
            }
          }),
        };
      });
    } else if (type == "remove") {
      setFullInfo((prev) => {
        return {
          ...prev,
          items: prev.items?.filter((v) => v.id != index),
        };
      });
      // setItems((prev) => prev.filter((v) => v.props.id != index));
    } else {
      setFullInfo((prev) => {
        return { ...prev, ...object };
      });
    }
  };
  const [updater, setUpdater] = useState(false);
  const [customer, setCustomer] = useState([]);
  const [optionShow, setOptionShow] = useState([]);
  const [customerVal, setcustomerVal] = useState([]);

  const [product, setProduct] = useState([]);
  const [option, setOption] = useState([
    { value: "0", label: "o1" },
    { value: "1", label: "po2" },
  ]);
  const [optionProduct, setOptionProduct] = useState([
    { value: "0", color: "قرمز " },
    { value: "1", color: "سبز" },
  ]);
  // func
  const reduceTwoArray = (bigArray, smallArray) => {
    let a = bigArray.filter((b) => !smallArray.find((s) => b.value == s.value));
    return a;
  };
  async function getProductFun() {
    let tempFormulationList = [];
    await getProduct({}).then((result) => {
      let temp = result.products?.filter((v) => [1, 2].includes(+v.main_type));

      let temp1 = reduceTwoArray(
        translateToReactSelect(false, temp, "title", true),
        tempFormulationList
      );
      let temp2 = temp1.map((value) => {
        return {
          ...value,
          order_options: value.order_options?.map((val) => {
            return {
              ...val,
              value: val.value?.map((v) => {
                return {
                  ...v,
                  value: { ...JSON.parse(v.value), checked: false },
                };
              }),
            };
          }),
          product_options: value.product_options?.map((v) => {
            return {
              ...v,
              checked: false,
            };
          }),
        };
      });

      setProduct(temp2);
    });
  }

  const productList = useMemo(
    () =>
      +fullInfo.type === 1
        ? product.filter((v) => +v.main_type === 2)
        : product.filter((v) => +v.main_type === 1),
    [fullInfo.type, product]
  );

  // user active
  async function getUserActiveFun() {
    await getUserActive({ conditions: `status/=/0` }).then((res) => {
      setCustomer(translateToReactSelect(false, res, "firstname", true));
    });
  }
  const customerOption = () => {
    let temp = customer.map((v) => {
      return {
        value: v.value,
        label: (
          <div>
            {v.corporate == 1
              ? `${v.company_name}(${v.label} ${v.lastname})`
              : `${v.label} ${v.lastname}`}
          </div>
        ),
      };
    });
    return temp;
  };
  const summaryData = useMemo(() => {
    let countProduct = 0;
    let countOption = 0;
    let optionList = "";
    let totalPrice = 0;
    let totalDiscount = 0;
    let optionPrice = 0;
    let time =
      fullInfo.save_tm === 0 || isNaN(fullInfo.save_tm)
        ? Math.floor(Date.now()) / 1000
        : fullInfo.save_tm;
    let timeStamp = time;
    const optionPriceFunc = (
      productPrice,
      perUnit,
      forOrder,
      unit,
      count,
      type
    ) => {
      let total = forOrder;
      if (unit == 2) {
        total += parseInt(perUnit) * parseInt(count);
      } else if (unit == 1) {
        let percentToPrice = (parseInt(productPrice) * parseInt(perUnit)) / 100;
        total += percentToPrice * parseInt(count);
      }

      return total;
    };
    fullInfo?.items?.map((v) => {
      countProduct += parseInt(v.count != "" ? v.count : 0);
      totalPrice += parseInt(v.price * v.count);
      totalDiscount += parseInt(v.discount);
      timeStamp +=
        v.product?.delivery_tm != undefined && v.product?.delivery_tm != ""
          ? parseInt(v.product?.delivery_tm)
          : 0;
      optionList +=
        v.product?.order_options != undefined
          ? v.product?.order_options?.map((x) =>
              x.value?.map((c) => {
                if (c.value?.checked == true) {
                  countOption += 1;
                  optionPrice += parseInt(
                    optionPriceFunc(
                      // v.product.price,
                      v.price,
                      c.value.pricePerUnit,
                      c.value.priceOnOrder,
                      c.value.unit,
                      v.count,
                      ""
                    )
                  );
                  return ` ${v.product.label}-${x[0].title}:${c.value.name}`;
                }
              })
            )
          : "";
    });
    console.log("fullinfo price data", fullInfo);

    return {
      countProduct: countProduct,
      totalPrice,
      totalDiscount: totalDiscount,
      optionList: optionList,
      countOption: countOption,
      optionPrice: optionPrice,
      timeStamp: timeStamp,
    };
  }, [fullInfo.save_tm, fullInfo.items]);
  const checkOptionHandler = (type, listId, optionId, valueId, selectValue) => {
    if (type == "orderOption") {
      let temp = { ...fullInfo };
      console.log(
        "checkOptionHandler",
        temp,
        "listId",
        listId,
        "optionId",
        optionId,
        "valueId",
        valueId
      );
      let temp2 = temp.items?.map((value) => {
        if (value.id == listId) {
          return {
            ...value,
            product: {
              ...value.product,
              order_options: value.product?.order_options?.map((val) => {
                if (val[0]?.id == optionId) {
                  return {
                    ...val,
                    value: val.value.map((v) => {
                      if (v.id == valueId) {
                        return {
                          ...v,
                          value: { ...v.value, checked: true },
                        };
                      } else
                        return {
                          ...v,
                          value: { ...v.value, checked: false },
                        };
                    }),
                  };
                } else return val;
              }),
            },
          };
          //  value.product?.order_options?.map((val) => {
          //   if (val[0]?.id == optionId) {
          //     return val.value.map((v) => {
          //       if (v.id == valueId) {
          //         return { ...v, value: { ...v.value, checked: true } };
          //       } else return { ...v };
          //     });
          //   } else return val;
          // });
        } else return value;
      });
      setFullInfo({ ...temp, items: temp2 });
    } else if (type === "fabricOptions") {
      let temp = { ...fullInfo };
      let temp2 = temp.items?.map((value) => {
        if (value.id == listId) {
          return {
            ...value,
            isChecked: false,
            piecesData: [
              {
                ...value.piecesData[0],
                datas: value.piecesData?.[0]?.datas?.map((val) => {
                  if (val?.id == optionId) {
                    return {
                      ...val,
                      value:
                        val.type === "select"
                          ? selectValue?.value
                          : selectValue?.target?.value,
                    };
                  } else return val;
                }),
              },
            ],
          };
        } else return value;
      });
      setFullInfo({ ...temp, items: temp2 });
    } else {
      let temp = { ...fullInfo };
      let temp2 = temp.items?.map((value) => {
        if (value.id == listId) {
          return {
            ...value,
            product: {
              ...value.product,
              product_options: value.product?.product_options?.map((val) => {
                if (val[0]?.id == optionId) {
                  return {
                    ...val,
                    selected: selectValue,
                    // value: val.value.map((v) => {
                    //   if (v.id == valueId) {
                    //     return { ...v, selected: selectValue };
                    //   } else return v;
                    // }),
                  };
                } else return val;
              }),
            },
          };
        } else return value;
      });
      setFullInfo({ ...temp, items: temp2 });
    }
  };
  const validation = () => {
    let validate = true;
    let proList = () => {
      let temp;
      fullInfo?.items?.map((v) => {
        if (
          v?.product_structure_id != 4 &&
          (v.count == 0 ||
            v.product.label == undefined ||
            v.discount > v.price * v.count)
        )
          temp = false;
        else return v;
      });
      return temp;
    };
    console.log("data?.product?.product_structure_id != 4 proList", proList);
    if (fullInfo.customerId == "" && fullInfo.type == 2) {
      validate = false;
      errorHandler({ customer: "لطفا مشتری را انتخاب کنید." });
    } else {
      errorHandler({ customer: "" });
    }
    if (fullInfo.type == "") {
      validate = false;
      errorHandler({ type: "نوع سفارش را نتخاب کنید." });
    } else {
      errorHandler({ type: "" });
    }

    if (fullInfo.recipient_name == "") {
      validate = false;
      errorHandler({ recipient_name: "لطفا نام خانودگی را وارد کنید." });
    } else {
      errorHandler({ recipient_name: "" });
    }
    if (fullInfo.recipient_phone == "") {
      validate = false;
      errorHandler({ recipient_phone: "لطفا شماره تماس را وارد کنید." });
    } else if (!mobileChecker(fullInfo.recipient_phone)) {
      validate = false;
      errorHandler({ recipient_phone: "شماره تماس وارد شده صحیح نیست." });
    } else {
      errorHandler({ recipient_phone: "" });
    }
    if (fullInfo.delivery_address == "") {
      validate = false;
      errorHandler({ delivery_address: "لطفا آدرس مورد نظر را وارد کنید." });
    } else {
      errorHandler({ delivery_address: "" });
    }
    if (fullInfo.operator_delivery_tm == "") {
      validate = false;
      errorHandler({
        operator_delivery_tm: "لطفا تاریخ مورد نظر را انتخاب کنید.",
      });
    } else {
      errorHandler({ operator_delivery_tm: "" });
    }
    console.log({ validate });
    if (proList() == false) {
      validate = false;
    }
    return validate;
  };
  useEffect(() => {
    getProductFun();
    getUserActiveFun();
  }, [updater]);
  useEffect(() => {
    if (type == "edit") {
      setFullInfo(orderData);
      setcustomerVal([
        {
          value: orderData?.customer?.id,
          label: (
            <div>
              {orderData?.customer?.corporate == 1
                ? `${orderData?.customer?.company_name}(${orderData?.customer?.firstname} ${orderData?.customer?.lastname})`
                : `${orderData?.customer?.firstname} ${orderData?.customer?.lastname}`}
            </div>
          ),
        },
      ]);
    }
  }, [orderData]);

  useEffect(() => {
    findFabrics().then((res) => {
      setAllFabrics(res.map((val) => ({ label: val.title, value: val.id })));
    });
  }, []);

  // console.log(fullInfo);
  // add order
  async function addOrderFun() {
    let productTemp = [];

    for (let i = 0; i < fullInfo.items.length; i++) {
      let x = [];
      let y = [];
      let z = [];
      fullInfo.items[i].product.product_options.map((v) => {
        if (v.selected != undefined) y.push(v);
      });
      z = fullInfo.items[i].product.order_options.map((v) => {
        let object1 = v;
        let array = [];
        object1.value.map((val) => {
          if (val.value.checked == true) {
            array.push(val);
          }
        });
        return { ...v, value: [...array] };
      });
      x = `${fullInfo.items[i].product.value}&&${fullInfo.items[i].count}&&${
        fullInfo.items[i].discount
      }&&${JSON.stringify(y)}&&${JSON.stringify(
        z.filter((v) => v.value.length > 0)
      )}&&${fullInfo.items[i]?.apfo_id ?? 0}`;

      productTemp.push(x);
    }
    let temp = {
      customer_id: fullInfo.customerId,
      delivery_address: fullInfo.delivery_address,
      recipient_phone: fullInfo.recipient_phone,
      recipient_name: `${fullInfo.recipient_name}`,
      save_tm: fullInfo.save_tm,
      operator_delivery_tm: fullInfo.operator_delivery_tm,
      system_delivery_tm: summaryData.timeStamp,
      type: fullInfo.type,

      product_services: productTemp.join("@@"), //psId,count, discount, price, params, price+option, optionorderitem
      status: -1, // TODO: why!?
    };
    type == "add" &&
      (await addOrder(temp).then((res) => {
        if (res.status == 1) {
          ToastCustomize({
            mainText: "سفارش با موفقیت اضافه شد",
            duration: 3000,
            toastType: "success",
            color: "success",
            position: "top-center",
            hasHeader: false,
          });
          navigate("/orders");
        } else {
          ToastCustomize({
            mainText: "مشکلی در ثبت پیش آماده است",
            duration: 3000,
            toastType: "danger",
            color: "danger",
            position: "top-center",
            hasHeader: false,
          });
        }
        // setCustomer(translateToReactSelect(false, res, "firstname", true));
      }));
    type == "edit" &&
      editOrderApi({
        ...temp,
        status: fullInfo.status,
        order_id: orderId,
      }).then((res) => {
        if (res.status == 1) {
          ToastCustomize({
            mainText: "سفارش با موفقیت  ویرایش شد",
            duration: 3000,
            toastType: "success",
            color: "success",
            position: "top-center",
            hasHeader: false,
          });
        } else {
          ToastCustomize({
            mainText: "مشکلی در ویرایش پیش آماده است",
            duration: 3000,
            toastType: "danger",
            color: "danger",
            position: "top-center",
            hasHeader: false,
          });
        }
      });
  }
  console.log("fullInfo fullInfo ***", fullInfo);
  return (
    <div className="p_addEdit ">
      <div
        className=" mx-4 mt-3  box"
        style={{ justifyContent: "space-between" }}
      >
        <div className="d-flex">
          {" "}
          <ReactSelect
            // itemsList={customer}
            itemsList={orderType}
            inputValue={orderType.filter((v) => v.value == fullInfo.type)}
            onChangeFunc={(e) => {
              setFullInfo({
                customerId: "",
                recipient_name: "",
                recipient_phone: "",
                delivery_address: "",
                CheckInput: "",
                save_tm: 0,
                operator_delivery_tm: 0,
                tax: 0,
                toll: 0,
                items: [],
              });
              if (e.value == 1) {
                setcustomerVal([]);
                changeHandlerFullInfo(
                  { type: e.value, customerId: "" },
                  "",
                  ""
                );
              } else changeHandlerFullInfo({ type: e.value }, "", "");
            }}
            id="titleTour"
            title="نوع سفارش"
            inputSize="lg"
            type="text"
            textErr={textError.type}
            inputContainer="pre-box-group me-2"
            activate={type == "edit" ? false : true}
          />
          {/* {fullInfo.type == 2 && ( */}
          <div className="box-group-first">
            <div className="box-inp">
              <ReactSelect
                // itemsList={customer}
                itemsList={customerOption()}
                inputValue={customerVal}
                onChangeFunc={(e) => {
                  setcustomerVal(e);
                  changeHandlerFullInfo({ customerId: e.value }, "", "");
                }}
                id="titleTour"
                title="مشتری"
                inputSize="lg"
                type="text"
                textErr={textError.customer}
                activate={type == "edit" ? false : true}
              />
            </div>
          </div>
          {/* )} */}
        </div>

        <div
          style={{ marginTop: "auto", marginBottom: "auto" }}
          className="ms-auto"
        >
          <CustomButton
            color="success"
            size="large"
            //   type="outline"
            state="normal"
            circle={false}
            onClick={(e) => {
              setUpdater((prev) => !prev);

              // ---------
              // let array = items;
              let lengthArray =
                fullInfo.items.length == 0
                  ? 0
                  : fullInfo.items[fullInfo.items.length - 1].id;
              // array.push(
              //   <OrderItems
              //     product={product}
              //     setProduct={setProduct}
              //     option={option}
              //     setOption={setOption}
              //     optionProduct={optionProduct}
              //     setOptionProduct={setOptionProduct}
              //     getProductFun={getProductFun}
              //     getProduct={getProduct}
              //     optionShow={optionShow}
              //     setOptionShow={setOptionShow}
              //     customerVal={customerVal}
              //     setcustomerVal={setcustomerVal}
              //     changeHandlerFullInfo={changeHandlerFullInfo}
              //     // id={array.length + 1}
              //     id={lengthArray}
              //   ></OrderItems>
              // );

              // setItems(array);
              // ----
              let temp = [...fullInfo.items];
              setFullInfo((prev) => {
                return {
                  ...prev,
                  items: [
                    ...temp,
                    {
                      isChecked: +fullInfo.type === 2 ? false : true,
                      product: { price: 0 },
                      count: 0,
                      price: 0,
                      apfo_id: 0,
                      discount: 0,
                      totalPrice: 0,
                      options: [],
                      // id: array.length + 1,
                      id: lengthArray + 1,
                    },
                  ],
                };
              });
            }}
          >
            افزودن آیتم سفارش
          </CustomButton>
        </div>
      </div>
      {fullInfo?.items?.map((value, index) => {
        // console.log("debug", value);

        return (
          <>
            <div className="text-center align-items-center mt-2">
              {value.product.label == undefined || value.count == 0 ? (
                <p
                  className="d-flex justify-content-center"
                  style={{ fontSize: 13, color: ColorSchema.danger_custom }}
                >
                  <div>انتخاب محصول و تعداد ضروری است.</div>
                  <ArrowBottomIcon
                    color={ColorSchema.danger_custom}
                    style={{ width: 20, height: 20 }}
                  />
                </p>
              ) : (
                ""
              )}
            </div>
            <OrderItems
              data={value}
              priceType={priceType}
              itemIndex={index}
              currentOrderType={fullInfo.type}
              product={productList}
              setProduct={setProduct}
              option={option}
              setOption={setOption}
              optionProduct={optionProduct}
              setOptionProduct={setOptionProduct}
              getProductFun={getProductFun}
              getProduct={getProduct}
              optionShow={optionShow}
              setOptionShow={setOptionShow}
              customerVal={customerVal}
              fabrics={allFabrics}
              setcustomerVal={setcustomerVal}
              changeHandlerFullInfo={changeHandlerFullInfo}
              checkOptionHandler={checkOptionHandler}
              submitHandler={submitHandler}
              // id={array.length + 1}
              // id={lengthArray}
              id={value.id}
            ></OrderItems>
          </>
        );
      })}
      {/* order option list  */}
      {/* <div className="mt-5 mx-3">
        <div className=" mt-2 ms-2" style={{ lineHeight: 1.6 }}>
          <ul>
            {fullInfo?.items?.map((value, itemIndex) => {
              return value.product?.order_options?.length > 0 ? (
                <li
                  style={{ listStyle: "circle" }}
                  className="my-3 border-bottom"
                >
                  <p style={{ fontWeight: "bold", listStyle: "circle" }}>
                    {value.product?.label}
                  </p>
                  <div>
                    {" "}
                    {value.product?.order_options?.map(
                      (optionValue, optionIndex) => {
                        return (
                          <div className="d-flex flex-wrap">
                            <h5 className="fw-bold">
                              {optionValue[0]?.title}:
                            </h5>
                            &nbsp; &nbsp;
                           
                            {optionValue?.value?.map((d, oValueIndex) => {
                              console.log("checkOptionHandler", value, d);
                              return (
                                <div className="d-flex flex-wrap align-items-center">
                                  {" "}
                                  <CheckInput
                                    key={`corporate-customer-1`}
                                    label={d.value?.name}
                                    type="radio"
                                    id={`corporate-radio-1-${itemIndex}-${optionIndex}-${oValueIndex}`}
                                    name={`corporate-radio-${itemIndex}-${optionIndex}`}
                                    // inputValue={recipient.CheckInput}
                                    inputValue={d.value?.checked}
                                    onChangeFunc={() =>
                                      checkOptionHandler(
                                        "orderOption",
                                        value.id,
                                        optionValue[0]?.id,
                                        d.id
                                      )
                                    }
                                  />
                                  &nbsp;&nbsp; (
                                  <span style={{ fontSize: 13 }}>
                                    تاثیر در قیمت واحد(
                                    {
                                      priceType.filter(
                                        (p) => p.value == d.value?.unit
                                      )?.[0]?.label
                                    }
                                    ): {addCommas(d.value?.pricePerUnit)}
                                    &nbsp;-&nbsp;
                                  </span>
                                  <span style={{ fontSize: 13 }}>
                                    تاثیر قیمت کل(تومان):{" "}
                                    {addCommas(d.value?.priceOnOrder)}
                                  </span>
                                  )
                                </div>
                              );
                            })}
                          </div>
                        );
                      }
                    )}
                  </div>
                </li>
              ) : (
                <></>
              );
            })}
          </ul>
        </div>
      </div> */}
      {/* <div className="d-flex mt-2 mx-3">
        <div>
          <div
            className="pt-3 mt-4 d-flex"
            style={{
              marginTop: "2px",
            }}
          >
            <div className="">
              <p
                style={{
                  fontSize: "13px",
                  textAlign: "justify",
                  marginTop: "5px",
                  marginRight: "6px",
                  color: ColorSchema.dark_custom,
                  lineHeight: 1.8,
                }}
              >
                اقلام :
                <span style={{ marginRight: "2px", marginLeft: "5px" }}>
                  <span
                    style={{
                      marginRight: "3px",
                      marginLeft: "3px",
                      color: ColorSchema.danger_custom,
                    }}
                  >
                    {fullInfo?.items?.map((v, i) => {
                      return (
                        <span>
                          {v?.product?.label}{" "}
                          {i < fullInfo?.items.length - 1 &&
                          v?.product?.label != undefined
                            ? ","
                            : ""}
                        </span>
                      );
                    })}
                  </span>
                  &nbsp;
                </span>
                تعداد :
                <span
                  style={{
                    marginRight: "3px",
                    marginLeft: "3px",
                    color: ColorSchema.danger_custom,
                  }}
                >
                  {summaryData.countProduct} &nbsp;
                </span>
                تعداد اپشن :
                <span
                  style={{
                    marginRight: "3px",
                    marginLeft: "3px",
                    color: ColorSchema.danger_custom,
                  }}
                >
                  8887 تومان
                </span>
                <span> لیست اپشن</span>
                <span
                  style={{
                    marginRight: "3px",
                    marginLeft: "3px",
                    color: ColorSchema.danger_custom,
                  }}
                >
                  33 تومان &nbsp;{" "}
                </span>
                قیمت کل :
                <span
                  style={{
                    marginRight: "3px",
                    marginLeft: "3px",
                    color: ColorSchema.danger_custom,
                  }}
                >
                  {addCommas(summaryData.totalPrice)} تومان &nbsp;
                </span>
                تخفیف :
                <span
                  style={{
                    marginRight: "3px",
                    marginLeft: "3px",
                    color: ColorSchema.danger_custom,
                  }}
                >
                  {addCommas(summaryData.totalDiscount)} تومان &nbsp;
                </span>
                مبلغ‌قابل‌پرداخت :
                <span
                  style={{
                    marginRight: "3px",
                    marginLeft: "3px",
                    color: ColorSchema.danger_custom,
                  }}
                >
                  {addCommas(
                    summaryData.totalPrice - summaryData.totalDiscount
                  )}{" "}
                  تومان &nbsp;
                </span>
              </p>
            </div>
          </div>
        </div>
      </div> */}
      {fullInfo?.items?.length > 0 && (
        <>
          <div className=" parent-info d-flex my-3">
            <div
              className="flex-grow-1 mx-4 items"
              style={{
                marginTop: 20,
                borderRadius: 10,
                border: `1px solid ${ColorSchema.info_custom}`,
              }}
            >
              <div className="justify-content-center p-3 ">
                {" "}
                <h5
                  className="border-bottom pb-2 mb-2"
                  style={{
                    textAlign: "center",
                    marginTop: "5px",
                    fontSize: "14px",
                    color: ColorSchema.secondary_custom,
                    fontWeight: "bold",
                  }}
                >
                  خلاصه فاکتور
                </h5>
                <div
                  className="my-1 d-flex flex-column justify-content-between"
                  style={{ fontSize: 14 }}
                >
                  <div className="d-flex my-3">
                    <h5 style={{ fontWeight: "bold" }} className="mt-1">
                      اقلام:{" "}
                    </h5>
                    &nbsp;&nbsp;&nbsp;
                    <div>
                      {fullInfo?.items?.map((v, i) => {
                        return (
                          <span style={{ lineHeight: 1.6 }}>
                            {v?.product?.label}
                            {v.product?.product_options?.map((t, i) => {
                              console.log("object", t);
                              return t.selected != undefined
                                ? `(${t[0]?.title}:${t.selected?.label}), `
                                : "";
                            })}

                            {i < fullInfo?.items.length - 1 &&
                            v?.product?.label != undefined
                              ? ","
                              : ""}
                          </span>
                        );
                      })}
                    </div>
                  </div>
                  <div className="d-flex my-3">
                    <div className="col-6 d-flex">
                      <h5 style={{ fontWeight: "bold" }}>تعداد اقلام: </h5>
                      &nbsp; &nbsp;
                      <div>{addCommas(summaryData.countProduct)} </div>
                    </div>
                    <div className="col-6 d-flex">
                      <h5 style={{ fontWeight: "bold" }}>قیمت اقلام: </h5>
                      <div>{addCommas(summaryData.totalPrice)} تومان</div>
                    </div>
                  </div>
                  <div className="d-flex my-3">
                    <h5
                      style={{ fontWeight: "bold", whiteSpace: "nowrap" }}
                      className="mt-1"
                    >
                      لیست آپشنهای انتخاب شده:{" "}
                    </h5>
                    &nbsp;&nbsp;&nbsp;
                    <div>
                      <span style={{ lineHeight: 1.6 }}>
                        {summaryData.optionList}
                      </span>
                      ;
                    </div>
                    <div></div>
                  </div>
                  <div className="d-flex my-3">
                    <div className="col-6 d-flex">
                      <h5 style={{ fontWeight: "bold" }}>تعداد آپشنها: </h5>
                      &nbsp; &nbsp;
                      <div>{addCommas(summaryData.countOption)} </div>
                    </div>
                    <div className="col-6 d-flex">
                      <h5 style={{ fontWeight: "bold" }}>قیمت آپشنها: </h5>
                      &nbsp; &nbsp;
                      <div>
                        {addCommas(
                          !isNaN(summaryData.optionPrice)
                            ? summaryData.optionPrice
                            : 0
                        )}{" "}
                        تومان
                      </div>
                    </div>
                  </div>
                  <div className="d-flex my-3">
                    {" "}
                    <div className="d-flex col-6 ">
                      <h5 style={{ fontWeight: "bold" }}>قیمت کل: </h5>
                      &nbsp;&nbsp;&nbsp;
                      <div>
                        {addCommas(
                          summaryData.totalPrice +
                            (!isNaN(summaryData.optionPrice)
                              ? summaryData.optionPrice
                              : 0)
                        )}{" "}
                        تومان
                      </div>
                    </div>{" "}
                    <div className="d-flex col-6">
                      <h5 style={{ fontWeight: "bold" }}>مبلغ تخفیف: </h5>
                      &nbsp;&nbsp;&nbsp;
                      <div>{addCommas(summaryData.totalDiscount)} تومان</div>
                    </div>
                  </div>

                  {/* {fullInfo?.type != undefined && fullInfo?.type == 2 && (
                    <div className="d-flex">
                      <div>
                        <CustomInput
                          id="titleTour"
                          label="مالیات(درصد)"
                          inputSize="lg"
                          type="text"
                          inputContainer=""
                          inputValue={fullInfo.tax}
                          onChangeFunc={(e) => {
                            // changeHandler(e.target.value, "fname");
                            if (!isNaN(e.target.value)) {
                              if (parseInt(e.target.value) <= 100) {
                                changeHandlerFullInfo(
                                  { tax: e.target.value },
                                  ""
                                );
                              } else {
                                ToastCustomize({
                                  mainText:
                                    "مقدار وارد شده باید کمتر از 100 باشد.",
                                  duration: 2000,
                                  toastType: "danger",
                                  color: "danger",
                                  position: "top-center",
                                  hasHeader: false,
                                });
                              }
                            } else {
                              ToastCustomize({
                                mainText: "لطفا عدد وارد کنید.",
                                duration: 2000,
                                toastType: "danger",
                                color: "danger",
                                position: "top-center",
                                hasHeader: false,
                              });
                            }
                          }}
                        />
                      </div>
                      <div>
                        <CustomInput
                          id="titleTour"
                          label="عوارض(درصد)"
                          inputSize="lg"
                          type="text"
                          inputContainer=""
                          inputValue={fullInfo.toll}
                          onChangeFunc={(e) => {
                            // changeHandler(e.target.value, "fname");
                            if (!isNaN(e.target.value)) {
                              if (parseInt(e.target.value) <= 100) {
                                changeHandlerFullInfo(
                                  { toll: e.target.value },
                                  ""
                                );
                              } else {
                                ToastCustomize({
                                  mainText:
                                    "مقدار وارد شده باید کمتر از 100 باشد.",
                                  duration: 2000,
                                  toastType: "danger",
                                  color: "danger",
                                  position: "top-center",
                                  hasHeader: false,
                                });
                              }
                            } else {
                              ToastCustomize({
                                mainText: "لطفا عدد وارد کنید.",
                                duration: 2000,
                                toastType: "danger",
                                color: "danger",
                                position: "top-center",
                                hasHeader: false,
                              });
                            }
                          }}
                        />
                      </div>
                    </div>
                  )} */}

                  <div className="d-flex my-3">
                    <h5 style={{ fontWeight: "bold" }}>مبلغ‌قابل‌پرداخت: </h5>
                    &nbsp;&nbsp;&nbsp;
                    <div>
                      {addCommas(
                        summaryData.totalPrice +
                          (!isNaN(summaryData.optionPrice)
                            ? summaryData.optionPrice
                            : 0) -
                          summaryData.totalDiscount
                      )}{" "}
                      تومان
                    </div>
                  </div>
                  <div className="d-flex my-3 align-items-center">
                    <h5 style={{ fontWeight: "bold" }}>انتخاب زمان ثبت:</h5>
                    &nbsp;&nbsp;&nbsp;
                    <div className="active-input">
                      {" "}
                      <DatePiker
                        inputSize="text"
                        width="150px"
                        value={parseInt(fullInfo.save_tm) * 1000}
                        setValue={(e) => {
                          changeHandlerFullInfo({ save_tm: e.unix }, "");
                        }}
                      ></DatePiker>
                    </div>
                  </div>
                  <div className="d-flex my-3 align-items-center">
                    <h5 style={{ fontWeight: "bold" }}>
                      زمان تحویل تقریبی(سیستمی):{" "}
                    </h5>
                    &nbsp;&nbsp;&nbsp;
                    <div className="disable-input">
                      {" "}
                      <DatePiker
                        inputSize="text"
                        width="150px"
                        value={summaryData.timeStamp * 1000}
                        readOnly={true}
                      ></DatePiker>
                    </div>
                  </div>
                  <div className="d-flex my-3 align-items-center">
                    <h5 style={{ fontWeight: "bold" }}>انتخاب زمان تحویل:</h5>
                    &nbsp;&nbsp;&nbsp;
                    <div className="active-input">
                      {" "}
                      <DatePiker
                        inputSize="text"
                        width="150px"
                        value={parseInt(fullInfo.operator_delivery_tm) * 1000}
                        setValue={(e) => {
                          changeHandlerFullInfo(
                            { operator_delivery_tm: e.unix },
                            ""
                          );
                        }}
                      ></DatePiker>
                      <div className="validate-style">
                        {textError.operator_delivery_tm}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {fullInfo.type == 2 && (
              <div
                className="box-info mx-4 items"
                style={{ border: `1px solid ${ColorSchema.danger_custom}` }}
              >
                <div className="d-flex flex-column h-100 justify-content-center p-3 ">
                  <h5
                    className="border-bottom pb-2 mb-2"
                    style={{
                      textAlign: "center",
                      marginTop: "5px",
                      fontSize: "14px",
                      color: ColorSchema.secondary_custom,
                      fontWeight: "bold",
                    }}
                  >
                    اطلاعات گیرنده
                  </h5>
                  <div className="row flex-grow-1">
                    <div className="box-group col-12  my-1">
                      <div className="box-inp">
                        <CustomInput
                          id="titleTour"
                          label="نام گیرنده"
                          inputSize="lg"
                          type="text"
                          inputContainer=""
                          // inputValue={recipient.fname}
                          inputValue={fullInfo.recipient_name}
                          onChangeFunc={(e) => {
                            changeHandler(e.target.value, "fname");
                            changeHandlerFullInfo(
                              { recipient_name: e.target.value },

                              "reci"
                            );
                          }}
                          textErr={textError.fname}
                        />
                      </div>
                    </div>
                    {/* <div className="box-group col-12  my-1">
                    <div className="box-inp">
                      <CustomInput
                        id="titleTour"
                        label="نام خانوادگی گیرنده"
                        inputSize="lg"
                        type="text"
                        inputContainer=""
                        inputValue={recipient.lname}
                        textErr={textError.lname}
                        onChangeFunc={(e) => {
                          changeHandler(e.target.value, "lname");
                          changeHandlerFullInfo(
                            { lname: e.target.value },

                            "reci"
                          );
                        }}
                      />
                    </div>
                  </div> */}
                    <div className="box-group col-12 my-1">
                      <div className="box-inp">
                        <CustomInput
                          id="titleTour"
                          label="شماره تماس "
                          inputSize="lg"
                          type="text"
                          inputContainer=""
                          // inputValue={recipient.recipient_phone}
                          inputValue={fullInfo?.recipient_phone}
                          textErr={textError?.recipient_phone}
                          onChangeFunc={(e) => {
                            if (isNaN(e.target.value)) {
                              errorHandler({
                                recipient_phone: "لطفا فقط عدد وارد کنید.",
                              });
                            } else {
                              changeHandler(e.target.value, "recipient_phone");
                              changeHandlerFullInfo(
                                { recipient_phone: e.target.value },

                                "reci"
                              );
                              errorHandler({ recipient_phone: "" });
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div className=" col-12 my-1">
                      <div className="box-inp">
                        <CustomInput
                          id="titleTour"
                          label="آدرس گیرنده "
                          inputSize="lg"
                          type="text"
                          inputContainer=""
                          // inputValue={recipient.delivery_address}
                          inputValue={fullInfo.delivery_address}
                          textErr={textError.delivery_address}
                          onChangeFunc={(e) => {
                            changeHandler(e.target.value, "delivery_address");
                            changeHandlerFullInfo(
                              { delivery_address: e.target.value },

                              "reci"
                            );
                          }}
                          inputType="textarea"
                        />
                      </div>
                    </div>
                    <div className=" col-12 my-1 mt-auto">
                      <div className="d-flex justify-content-end mt-2 ">
                        <CustomButton
                          color="success"
                          size="large"
                          type="outline"
                          state={submitButtonIsDisable ? "deactive" : "normal"}
                          circle={false}
                          onClick={() => {
                            console.log(
                              "data?.product_structure_id proList"
                              // validation()
                            );
                            if (validation()) {
                              console.log("data?.product_structure_id proList");
                              addOrderFun();
                            } else {
                              ToastCustomize({
                                mainText: "اطلاعات وارد شده ناقص است.",
                                duration: 2000,
                                toastType: "danger",
                                color: "danger",
                                position: "top-center",
                                hasHeader: false,
                              });
                            }
                          }}
                        >
                          ثبت سفارش
                        </CustomButton>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          {fullInfo.type != 2 && (
            <div className=" col-12 my-1  mt-auto">
              <div className="d-flex justify-content-end mt-2 me-5">
                <CustomButton
                  color="success"
                  size="large"
                  type="outline"
                  state={submitButtonIsDisable ? "deactive" : "normal"}
                  circle={false}
                  onClick={() => {
                    console.log(validation());
                    if (validation()) {
                      addOrderFun();
                    } else {
                      ToastCustomize({
                        mainText: "اطلاعات وارد شده ناقص است.",
                        duration: 2000,
                        toastType: "danger",
                        color: "danger",
                        position: "top-center",
                        hasHeader: false,
                      });
                    }
                  }}
                >
                  ثبت سفارش
                </CustomButton>
              </div>
            </div>
          )}
          {/* <div className="d-flex ">
            <div>
              <label
                style={{ color: ColorSchema.dark_custom, fontSize: "14px" }}
              >
                {" "}
                زمان تحویل:
              </label>
              <label
                style={{
                  color: ColorSchema.danger_custom,
                  fontSize: "14px",
                }}
              >
                1401/11/11
              </label>
            </div>
            <div className="d-flex mx-4">
              <label
                style={{ color: ColorSchema.dark_custom, fontSize: "14px" }}
              >
                {" "}
                انتخاب زمان:
              </label>
              <div style={{ marginTop: "-10px" }}>
                <DatePiker
                  inputSize="text"
                  width="150px"
                  // value={filterData.firstFactorTo}
                  //         setValue={(e) => {
                  //           changeHandler(e, "firstFactorTo");
                  //         }}
                ></DatePiker>
              </div>
            </div>
          </div> */}
        </>
      )}
    </div>
  );
}
